import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import ErrorIcon from '@material-ui/icons/Error';
import CloseIcon from '@material-ui/icons/Close';
import red from '@material-ui/core/colors/red';
import DialogContentText from '@material-ui/core/DialogContentText';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import request from 'superagent'
import * as Constants from '../constants'

const styles = theme => ({
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});

class RequestChildDialog extends React.Component {
  state = {
    message: "",
    loading: false,
    error_message: "",
    snackbar_open: false,
  }

  onSend = () => {
    this.setState({ loading: true })
    let currentComponent = this;
    request.post(Constants.BACKEND_URL)
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .set('accept', 'json')
      .send({ command: "requestchild", parent_id: this.props.parentId, child_id: this.props.childId, message: this.state.message })
      .end((err, res) => {
        var result = res.text.trim();
        if (result === "1") {
          //Erfolgreich gesendet
          currentComponent.props.onClose();
          currentComponent.onReset();
        } else {
          currentComponent.setState({ error_message: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.", snackbar_open: true, loading: false });
        }
      });
    this.onReset();
  }

  onReset = () => {
    this.setState({ message: "", loading: false })
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  }

  render() {
    const { fullScreen, classes } = this.props;

    return (
      <Dialog fullScreen={fullScreen} open={this.props.open} BackdropProps={{ style: { backgroundColor: "transparent" } }}>
        <DialogTitle>{"Zuordnung anfordern"}</DialogTitle>
        <DialogContent style={{ paddingLeft: 20, paddingRight: 20 }}>
          <DialogContentText>Dieses Kind ist bereits einem anderen Nutzerkonto zugeordnet. Wollen Sie mit diesem Nutzer Kontakt aufnehmen? Für die Zuordnung werden dieser Person Ihr Name und E-Mail Adresse übermittelt.</DialogContentText>
          {/* Nachricht */}
          <TextField label="Optionale Nachricht hinzufügen ..." multiline rows="4" value={this.state.message} onChange={this.handleChange('message')} style={{ width: "100%" }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose} variant="contained" disabled={this.state.loading}>Abbrechen</Button>
          <Button onClick={this.onReset} variant="contained" disabled={this.state.loading}>Formular zurücksetzen</Button>
          <Button onClick={this.onSend} variant="contained" disabled={this.state.loading} color="primary" autoFocus>
            Anfrage senden
            {this.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
          </Button>
        </DialogActions>
        {/* Error-Snackbar */}
        <Snackbar className={classes.success} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={this.state.snackbar_open} autoHideDuration={3000} onClose={this.handleSnackbarClose}>
          <SnackbarContent
            message={
              <span className={classes.message}>
                <ErrorIcon className={classes.icon} />{this.state.error_message}
              </span>
            }
            action={[
              <IconButton color="inherit" key="close" onClick={this.handleSnackbarClose}>
                <CloseIcon style={{ fontSize: 20 }} />
              </IconButton>,
            ]}
            style={{ backgroundColor: red[600] }} />
        </Snackbar>
      </Dialog>
    );
  }
}

RequestChildDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  fullScreen: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  parentId: PropTypes.string.isRequired,
  childId: PropTypes.string.isRequired,
};

export default withMobileDialog()(withStyles(styles, { withTheme: true })(RequestChildDialog));
